import { useEffect, useState } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Swal from "sweetalert2";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayoutMin from "examples/LayoutContainers/DashboardLayoutMin";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import DynamicDialog from "components/MDDialog";
import { hasPermissionDirect } from "../../../utils/hasPermissions";
import fetchTableData from "../../../utils/fetchTableData";
import RowFeeCategoryActionsMenu from "./RowFeeCategoryActionsMenu";
import RowFeeTypeActionsMenu from "./RowFeeTypeActionsMenu";
import { Chip, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { DataGrid } from "@mui/x-data-grid";
function FeeCategory() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const ActiveStatusCell = ({ value }) => (
    <Chip
      label={value === "ACTIVE" ? "Active" : "Inactive"}
      color={value === "ACTIVE" ? "success" : "error"}
      size="medium"
      variant="outlined"
    />
  );
  ActiveStatusCell.propTypes = {
    value: PropTypes.string.isRequired,
  };

  const getAuthHeaders = () => {
    const token = sessionStorage.getItem("token");
    return {
      Authorization: `Bearer ${token}`,
    };
  };
  const [rowCount, setRowCount] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [fccolumns, setFCColumns] = useState([]);
  const [fcrows, setFCRows] = useState([]);
  const [fcopen, setFCOpen] = useState(false);
  const [fceditingId, setFCEditingId] = useState(null);
  const [feeCategoryFormErrors, setFeeCategoryFormErrors] = useState({});
  const [feeCategoryFormData, setFeeCategoryFormData] = useState({
    fee_category_id: "",
    fee_category_name: "",
    fee_category_letter: "",
    status: "ACTIVE",
  });

  const [ftcolumns, setFTColumns] = useState([]);
  const [ftrows, setFTRows] = useState([]);
  const [ftopen, setFTOpen] = useState(false);
  const [openFeeTypesData, setOpenFeeTypesView] = useState(false);
  const [fteditingId, setFTEditingId] = useState(null);
  const [feeCategoryId, setFeeCategoryId] = useState(null);
  const [feeCategoryName, setFeeCategoryName] = useState(null);
  const [feeTypeFormErrors, setFeeTypeFormErrors] = useState({});
  const [feeTypeFormData, setFeeTypeFormData] = useState({
    fee_type_id: "",
    fee_type_name: "",
    fee_type_desc: "",
    is_bank_deposit: 0,
    status: "ACTIVE",
  });

  useEffect(() => {
    const userData = sessionStorage.getItem("user");
    if (userData) {
      const parsedUser = JSON.parse(userData);
      setUser(parsedUser);
    }
  }, []);

  useEffect(() => {
    if (user) {
      fetchFeeCategories();
    }
  }, [user]);

  // Fetch Fee Categories
  const fetchFeeCategories = async () => {
    await fetchTableData({
      url: `${API_BASE_URL}/api/fee-categories/${user.client_id}/${user.college_id}`,
      onEdit: handleFeeCategoryEdit,
      onDelete: handleFeeCategoryDelete,
      onExtraAction: {
        onCreateFeeType: openFeeTypeDialog,
        onViewFeeTypes: fetchFeeTypes,
        db_instance_id: user.db_instance_id,
        hasPermissionDirect,
      },
      setColumns: setFCColumns,
      setRows: setFCRows,
      customActionComponent: (props) => (
        <RowFeeCategoryActionsMenu
          {...props}
          onCreateFeeType={props.onExtraAction?.onCreateFeeType}
          onViewFeeTypes={props.onExtraAction?.onViewFeeTypes}
          db_instance_id={props.onExtraAction?.db_instance_id}
          hasPermissionDirect={props.onExtraAction?.hasPermissionDirect}
        />
      ),
    });
  };

  const handleFeeCategoryEdit = (row) => {
    setFeeCategoryFormData({ ...row });
    setFCEditingId(row.fee_category_id);
    setFCOpen(true);
  };

  const handleFeeCategoryDelete = async (fee_category_id) => {
    const confirm1 = await Swal.fire({
      title: "Sure to delete FeeCategory?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      willOpen: () => {
        const container = document.querySelector(".swal2-container");
        if (container) {
          container.style.zIndex = "20000";
        }
      },
    });

    if (confirm1.isConfirmed) {
      try {
        const response = await axios.delete(
          `${API_BASE_URL}/api/fee-categories/${user.client_id}/${user.college_id}/${fee_category_id}`,
          { headers: getAuthHeaders() }
        );
        if (response.status === 200) {
          showSnackbar("Fee Category Deleted successfully", "success");
        } else {
          showSnackbar("Fee Category is not Deleted ", "error");
        }
        fetchFeeCategories();
      } catch (err) {
        showSnackbar("Error deleting Fee Category", "error");
      }
    }
  };

  const handleFeeCategorySave = async () => {
    const errors = {};
    if (!feeCategoryFormData.fee_category_name?.trim()) {
      errors.fee_category_name = "Fee Category Name is required";
    }
    if (!feeCategoryFormData.fee_category_letter?.trim()) {
      errors.fee_category_letter = "Fee Category Letter is required";
    }
    setFeeCategoryFormErrors(errors);
    if (Object.keys(errors).length > 0) return;

    const userEmail = user?.user_email || "unknown";
    try {
      let response;
      if (fceditingId) {
        response = await axios.put(
          `${API_BASE_URL}/api/fee-categories/${user.client_id}/${user.college_id}/${fceditingId}`,
          { ...feeCategoryFormData, updated_by: userEmail },
          { headers: getAuthHeaders() }
        );
      } else {
        response = await axios.post(
          `${API_BASE_URL}/api/fee-categories/${user.client_id}/${user.college_id}`,
          { ...feeCategoryFormData, created_by: userEmail },
          { headers: getAuthHeaders() }
        );
      }
      if (response.status === 200) {
        showSnackbar(response.data.message || "Saved successfully", "success");
      } else {
        showSnackbar("Something went wrong. Please try again.", "error");
      }
      setFCOpen(false);
      fetchFeeCategories();
    } catch (error) {
      showSnackbar("Error saving Fee Category", "error");
    }
  };

  const fetchFeeTypes = async (fee_category_id, fee_category_name) => {
    await fetchTableData({
      url: `${API_BASE_URL}/api/fee-types/${user.client_id}/${user.college_id}/${fee_category_id}`,
      onEdit: handleFeeTypeEdit,
      onDelete: handleFeeTypeDelete,
      onExtraAction: {
        onCreateFeeType: openFeeTypeDialog,
        onViewFeeTypes: fetchFeeTypes,
        db_instance_id: user.db_instance_id,
        hasPermissionDirect,
      },
      setColumns: setFTColumns,
      setRows: setFTRows,
      customActionComponent: (props) => (
        <RowFeeTypeActionsMenu
          {...props}
          hasPermissionDirect={props.onExtraAction?.hasPermissionDirect}
        />
      ),
    });
    setOpenFeeTypesView(true);
    setFTOpen(false);
    setFeeCategoryId(fee_category_id);
    setFeeCategoryName(fee_category_name);
  };

  const openFeeTypeDialog = (fee_category_id, fee_category_name) => {
    setFeeTypeFormData({
      fee_category_id,
      fee_type_name: "",
      fee_type_desc: "",
      is_bank_deposit: 0,
      status: "ACTIVE",
    });
    setFTOpen(true);
    setFTEditingId(null);
    setFeeCategoryId(fee_category_id);
    setFeeCategoryName(fee_category_name);
    setFeeTypeFormErrors({});
  };

  const handleFeeTypeEdit = (row) => {
    setFeeTypeFormData({ ...row });
    setFTEditingId(row.fee_type_id);
    setFTOpen(true);
  };

  const handleFeeTypeDelete = async (fee_type_id, fee_category_id) => {
    const confirm2 = await Swal.fire({
      title: "Sure to delete FeeType?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      willOpen: () => {
        const container = document.querySelector(".swal2-container");
        if (container) {
          container.style.zIndex = "20000";
        }
      },
    });

    if (confirm2.isConfirmed) {
      try {
        const response = await axios.delete(
          `${API_BASE_URL}/api/fee-types/${user.client_id}/${user.college_id}/${fee_category_id}/${fee_type_id}`,
          { headers: getAuthHeaders() }
        );
        if (response.status === 200) {
          showSnackbar("Fee Type Deleted successfully", "success");
        } else {
          showSnackbar("Fee Type is not Deleted ", "error");
        }
        fetchFeeTypes(feeCategoryId, feeCategoryName);
      } catch (err) {
        showSnackbar("Error deleting Fee Type", "error");
      }
    }
  };

  const handleFeeTypeSave = async () => {
    const errors = {};
    if (!feeTypeFormData.fee_type_name?.trim()) {
      errors.fee_type_name = "Fee Type Name is required";
    }
    if (!feeTypeFormData.fee_type_desc?.trim()) {
      errors.fee_type_desc = "Fee Type Description is required";
    }
    setFeeTypeFormErrors(errors);
    if (Object.keys(errors).length > 0) return;

    const userEmail = user?.user_email || "unknown";
    try {
      let response;
      if (fteditingId) {
        response = await axios.put(
          `${API_BASE_URL}/api/fee-types/${user.client_id}/${user.college_id}/${feeCategoryId}/${fteditingId}`,
          { ...feeTypeFormData, updated_by: userEmail },
          { headers: getAuthHeaders() }
        );
      } else {
        response = await axios.post(
          `${API_BASE_URL}/api/fee-types/${user.client_id}/${user.college_id}/${feeCategoryId}`,
          { ...feeTypeFormData, created_by: userEmail },
          { headers: getAuthHeaders() }
        );
      }

      if (response.status === 200) {
        showSnackbar(response.data.message || " Fee Type is Saved successfully", "success");
      } else {
        showSnackbar("Something went wrong. Please try again.", "error");
      }
      fetchFeeTypes(feeCategoryId, feeCategoryName);
      setFTOpen(false);
      //fetchFeeTypes(feeCategoryId, feeCategoryName);
    } catch (error) {
      showSnackbar("Error saving Fee Type", "error");
    }
  };

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const feecategoryfields = [
    {
      name: "fee_category_name",
      label: "Fee Category Name",
      type: "text",
    },
    {
      name: "fee_category_letter",
      label: "Fee Category Letter",
      type: "text",
    },
    fceditingId && {
      name: "status",
      label: "Status",
      type: "select",
      options: [
        { value: "ACTIVE", label: "Active" },
        { value: "INACTIVE", label: "Inactive" },
      ],
    },
  ].filter(Boolean);

  const feetypefields = [
    {
      name: "fee_type_name",
      label: "Fee Type Name",
      type: "text",
    },
    {
      name: "fee_type_desc",
      label: "Fee Type Description",
      type: "text",
    },
    {
      name: "is_bank_deposit",
      label: "Is Bank Deposit?",
      type: "select",
      options: [
        { value: 1, label: "Yes" },
        { value: 0, label: "No" },
      ],
    },
    {
      name: "status",
      label: "Status",
      type: "select",
      options: [
        { value: "ACTIVE", label: "Active" },
        { value: "INACTIVE", label: "Inactive" },
      ],
    },
  ].filter(Boolean);

  const handleFeeCategoryChange = (name, value) => {
    setFeeCategoryFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFeeTypeChange = (name, value) => {
    setFeeTypeFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <DashboardLayoutMin>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDBox display="flex" justifyContent="space-between" alignItems="center">
                  <MDTypography variant="h6" color="white">
                    FEE CATEGORIES MANAGEMENT
                  </MDTypography>
                  {hasPermissionDirect("create") && (
                    <MDButton
                      variant="contained"
                      color="info"
                      onClick={() => {
                        setFCOpen(true);
                        setFeeCategoryFormData({});
                        setFeeCategoryFormErrors({});
                        setFCEditingId(null);
                      }}
                    >
                      <Icon>add</Icon> Add Fee Category
                    </MDButton>
                  )}
                </MDBox>
              </MDBox>
              {fccolumns.length > 0 && fcrows.length > 0 && (
                <MDBox pt={2}>
                  <DataTable
                    table={{ columns: fccolumns, rows: fcrows }}
                    isSorted={true}
                    entriesPerPage={true}
                    showTotalEntries={true}
                    canSearch={true}
                    noEndBorder
                  />
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={() => setSnackbarOpen(false)}>
        <MuiAlert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          elevation={6}
          variant="filled"
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
      <DynamicDialog
        open={fcopen}
        onClose={() => setFCOpen(false)}
        title={fceditingId ? "Edit Fee Category" : "Add Fee Category"}
        formData={feeCategoryFormData}
        formErrors={feeCategoryFormErrors}
        fields={feecategoryfields}
        onChange={handleFeeCategoryChange}
        onSave={handleFeeCategorySave}
      />
      <DynamicDialog
        open={ftopen}
        onClose={() => setFTOpen(false)}
        title={
          fteditingId
            ? "Edit Fee Type of " + `${feeCategoryName}`
            : "Add Fee Type for " + `${feeCategoryName}`
        }
        formData={feeTypeFormData}
        formErrors={feeTypeFormErrors}
        fields={feetypefields}
        onChange={handleFeeTypeChange}
        onSave={handleFeeTypeSave}
      />
      <Dialog
        open={openFeeTypesData}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setOpenFeeTypesView(false);
          }
        }}
        fullWidth
        maxWidth={false}
        sx={{
          "& .MuiDialog-paper": {
            width: "80%",
            maxWidth: "none",
            zIndex: 2000,
          },
        }}
      >
        <DialogTitle>
          FeeTypes List of {feeCategoryName}
          <IconButton onClick={() => setOpenFeeTypesView(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            background: "linear-gradient(to bottom,hsl(233, 24.30%, 92.70%),rgb(206, 213, 225))",
            padding: 2,
          }}
        >
          <MDBox pt={2}>
            <DataTable
              table={{ columns: ftcolumns, rows: ftrows }}
              isSorted={true}
              entriesPerPage={true}
              showTotalEntries={true}
              canSearch={true}
              noEndBorder
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            color="success"
            onClick={() => setOpenFeeTypesView(false)}
            sx={{
              background: "linear-gradient(45deg,rgb(239, 43, 21),rgb(224, 73, 31))",
              color: "#fff",
              "&:hover": {
                background: "linear-gradient(45deg,rgb(210, 77, 25),rgb(242, 122, 53))",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayoutMin>
  );
}

FeeCategory.propTypes = {
  onExtraAction: PropTypes.shape({
    onCreateFeeType: PropTypes.func,
    onViewFeeTypes: PropTypes.func,
    db_instance_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    hasPermissionDirect: PropTypes.func,
  }),
};
export default FeeCategory;
